// @ts-nocheck

import * as SportIconPaths from '../../assets/img/sports';
import { SportIds } from '../../types/sports';

export const MultimatchSportIconsBySportId = {
  [SportIds.SOCCER]: SportIconPaths.FootballMultimatch,
};

export const SportIconsBySportId = new Proxy(
  {
    [SportIds.ARCHERY]: SportIconPaths.Archery,
    [SportIds.DIVING]: SportIconPaths.Diving,
    [SportIds.EQUESTRIAN]: SportIconPaths.Equestrian,
    [SportIds.ROWING]: SportIconPaths.Rowing,
    [SportIds.SKATEBOARDING]: SportIconPaths.Skate,
    [SportIds.TRIATHLON]: SportIconPaths.Triathlon,
    [SportIds.WEIGHTLIFTING]: SportIconPaths.Weightlifting,
    [SportIds.WRESTLING]: SportIconPaths.Wrestling,
    [SportIds.ATHLETICS]: SportIconPaths.Athletics,
    [SportIds.SOCCER]: SportIconPaths.Football,
    [SportIds.BADMINTON]: SportIconPaths.Badminton,
    [SportIds.BASEBALL]: SportIconPaths.Baseball,
    [SportIds.BASKETBALL]: SportIconPaths.Basket,
    [SportIds.BEACH_VOLLEY]: SportIconPaths.BeachVolley,
    [SportIds.BOXING]: SportIconPaths.Boxing,
    [SportIds.CURLING]: SportIconPaths.Curling,
    [SportIds.CYCLING]: SportIconPaths.Cycling,
    [SportIds.FIELD_HOCKEY]: SportIconPaths.FieldHockey,
    [SportIds.SOCCER]: SportIconPaths.Football,
    [SportIds.FOOTBALL]: SportIconPaths.FootballUs,
    [SportIds.FENCING]: SportIconPaths.Fencing,
    [SportIds.GOLF]: SportIconPaths.Golf,
    [SportIds.HANDBALL]: SportIconPaths.Handball,
    [SportIds.ICEHOCKEY]: SportIconPaths.IceHockey,
    [SportIds.JUDO]: SportIconPaths.Judo,
    [SportIds.KABADDI]: SportIconPaths.Kabaddi,
    [SportIds.MOTOR_SPORT]: SportIconPaths.Motorsport,
    [SportIds.OLYMPICS]: SportIconPaths.Olympics,
    [SportIds.PETANQUE]: SportIconPaths.Petanque,
    [SportIds.SNOOKER]: SportIconPaths.Snooker,
    [SportIds.SWIMMING]: SportIconPaths.Swimming,
    [SportIds.OPEN_WATER_SWIMMING]: SportIconPaths.Swimming,
    [SportIds.TABLE_TENNIS]: SportIconPaths.TableTennis,
    [SportIds.TENNIS]: SportIconPaths.Tennis,
    [SportIds.SAILING]: SportIconPaths.Sailing,
    [SportIds.VOLLEYBALL]: SportIconPaths.Volley,
    [SportIds.WATERPOLO]: SportIconPaths.Waterpolo,
    [SportIds.WINTER_SPORTS]: SportIconPaths.Wintersports,
    [SportIds.BANDY]: SportIconPaths.Bandy,
    [SportIds.BEACH_SOCCER]: SportIconPaths.BeachSoccer,
    [SportIds.BOWLS]: SportIconPaths.Bowls,
    [SportIds.CHESS]: SportIconPaths.Chess,
    [SportIds.CRICKET]: SportIconPaths.Cricket,
    [SportIds.DARTS]: SportIconPaths.Darts,
    [SportIds.ESPORT_COUNTER_STRIKE]: SportIconPaths.Esport,
    [SportIds.ESPORT_LEAGUE_OF_LEGENDS]: SportIconPaths.Esport,
    [SportIds.ESPORT_DOTA]: SportIconPaths.Esport,
    [SportIds.ESPORT_COD]: SportIconPaths.Esport,
    [SportIds.ESPORT_STREET_FIGHTER_V]: SportIconPaths.Esport,
    [SportIds.ESPORT_OVERWATCH]: SportIconPaths.Esport,
    [SportIds.ESPORT]: SportIconPaths.Esport,
    [SportIds.FORMULA_1]: SportIconPaths.Formula1,
    [SportIds.FLOORBALL]: SportIconPaths.Floorball,
    [SportIds.AUSSIE_RULES]: SportIconPaths.FootballAussie,
    [SportIds.FUTSAL]: SportIconPaths.Futsal,
    [SportIds.GAELICSPORT]: SportIconPaths.GaelicSport,
    [SportIds.GAELICHURLING]: SportIconPaths.GaelicSport,
    [SportIds.GAELICFOOTBALL]: SportIconPaths.GaelicSport,
    [SportIds.NETBALL]: SportIconPaths.Netball,
    [SportIds.PADEL]: SportIconPaths.Padel,
    [SportIds.PESAPALLO]: SportIconPaths.Pesapallo,
    [SportIds.POLITICS]: SportIconPaths.Politic,
    [SportIds.POOL]: SportIconPaths.Snooker,
    [SportIds.RUGBY_LEAGUE]: SportIconPaths.Rugby13,
    [SportIds.RUGBY_7S]: SportIconPaths.Rugby7,
    [SportIds.RUGBY_LEAGUE_OLD]: SportIconPaths.Rugby13,
    [SportIds.RUGBY_7S_OLD]: SportIconPaths.Rugby7,
    [SportIds.BASKETBALL_3]: SportIconPaths.Basket3,
    [SportIds.SQUASH]: SportIconPaths.Squash,
    [SportIds.SURF]: SportIconPaths.Surf,
    // [SportIds.SPECIAL_ODDS]: SportIconPaths.SpecialOdd,
    [SportIds.SPECIALS]: SportIconPaths.SpecialOdd,
    [SportIds.SPECIALS__99999]: SportIconPaths.SpecialOdd,
    [SportIds.MMA]: SportIconPaths.Mma,
    [SportIds.SPECIAL_ODD_TV]: SportIconPaths.Tv,
    [SportIds.LACROSSE]: SportIconPaths.Lacrosse,
    [SportIds.RUGBY]: SportIconPaths.Rugby15,
    [SportIds.ALPINE]: SportIconPaths.SkiAlpin,
    [SportIds.BIATHLON]: SportIconPaths.Biathlon,
    [SportIds.MOTO]: SportIconPaths.MotoGP,
    [SportIds.FREESTYLE_SKIING]: SportIconPaths.SkiFreestyle,
    [SportIds.CROSS_COUNTRY]: SportIconPaths.SkiDeFond,
    [SportIds.SNOWBOARD]: SportIconPaths.Snowboard,
    [SportIds.LUGE]: SportIconPaths.Luge,
    [SportIds.SOCCER_7]: SportIconPaths.Football7,
    [SportIds.SKI_JUMPING]: SportIconPaths.SautSki,
    [SportIds.NORDIC_COMBINED]: SportIconPaths.NordicCombined,
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return SportIconPaths.Fallback;
      }
      return origin[key];
    },
  },
);
